//      
import {                             } from 'css-box-model';
import isWithin from '../is-within';

export default function isPositionInFrame(frame         ) {
  const isWithinVertical = isWithin(frame.top, frame.bottom);
  const isWithinHorizontal = isWithin(frame.left, frame.right);

  return function run(point          ) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/visibility/is-position-in-frame.js